import React from 'react';
import { Col, Modal, Form, Input, Row, Button } from 'antd';

const layout = {
	labelCol: { span: 8 },
	wrapperCol: { span: 14 },
};

const ViewSummaryModal = ({ formRef, showCreateComm, summaryForm, onFinishModal, setshowCreateComm, handleSummaryForm }) => {
	return (
		<Modal
			// visible={summaryForm.summaryModal}
			visible={showCreateComm}
			title={null}
			centered={true}
			footer={null}
			closable={false}
			style={{ minWidth: '50%' }}
			destroyOnClose={true}
			className="view_summary_modal">
			<Col>
				<Col className="modal_header">Add Commission Item</Col>
				<Col className="modal_Body">
					<Form
						hideRequiredMark={true}
						style={{ margin: '20px 0px' }}
						{...layout}
						layout="horizontal"
						form={formRef}
						onFinish={onFinishModal}>
						<Form.Item className="full_border" name="email" label="Email Id" rules={[]}>
							<Input value={summaryForm.userName} />
						</Form.Item>
						<Form.Item className="full_border" name="Customer" label="Customer" rules={[]}>
							<Input value={summaryForm.userName} />
						</Form.Item>
						<Form.Item className="full_border" name="Order Id" label="orderId" rules={[]}>
							<Input value={summaryForm.userName} />
						</Form.Item>
						<Form.Item className="full_border" name="product" label="Product" rules={[]}>
							<Input value={summaryForm.userName} />
						</Form.Item>
						<Form.Item className="full_border" name="productPrice" label="Product Price" rules={[]}>
							<Input value={summaryForm.userName} />
						</Form.Item>
						<Form.Item className="full_border" name="Commission" label="Commission %" rules={[]}>
							<Input value={summaryForm.userName} />
						</Form.Item>
						<Form.Item className="full_border" name="CommissionPrice" label="Commission Price" rules={[]}>
							<Input value={summaryForm.userName} />
						</Form.Item>
						<Col style={{ textAlign: 'right' }}>
							<Button className="cancel_btn" onClick={(e) => handleSummaryForm('summaryModal', false)}>
								Cancel
							</Button>
							{/* <Button className="submit_btn" onClick={(e) => handleSummaryForm('summaryModal', false)}> */}
							<Button className="submit_btn" onClick={(e) => setshowCreateComm(false)}>
								Submit
							</Button>
						</Col>
					</Form>
				</Col>
			</Col>
		</Modal>
	);
};

export default ViewSummaryModal;
